module.exports = __webpack_public_path__ + "static/media/bus-card1.77f54bc9.png";